
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'TripNotFoundSection'
})
export default class TripNotFoundSection extends Vue {
  private reload() {
    location.reload();
  }
}
